
import type { HTMLAttributes } from 'react';
import { cn } from "@/lib/utils"

interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'table' | 'text' | 'circular' | 'rectangular';
  intensity?: 'subtle' | 'light' | 'medium';
  shimmer?: boolean;
}

function Skeleton({
  className,
  variant = 'default',
  intensity = 'light',
  shimmer = true,
  ...props
}: SkeletonProps) {
  const intensityClasses = {
    subtle: 'bg-muted/40',
    light: 'bg-muted/60',
    medium: 'bg-muted/80'
  };

  const variantClasses = {
    default: 'rounded-md',
    table: 'rounded-none',
    text: 'rounded-sm',
    circular: 'rounded-full',
    rectangular: 'rounded-none'
  };

  return (
    <div
      className={cn(
        "relative overflow-hidden",
        variantClasses[variant],
        intensityClasses[intensity],
        shimmer && "skeleton-shimmer",
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
